import { FC, useState, Dispatch, SetStateAction, useCallback } from 'react';

import { MonthItem, YearTabProps } from '../interface';
import { SearchMonthListWrapper } from '../styled';
import ToggleTabPanel from './ToggleTabPanel';
import YearTab from './YearTab';

interface Props {
  currentYearTab: YearTabProps;
  setCurrentYearTab: Dispatch<SetStateAction<YearTabProps>>;
  nextYearTab: YearTabProps;
  setNextYearTab: Dispatch<SetStateAction<YearTabProps>>;
  inputComponent?: 'shopAndFly' | 'setur';
}

const SearchMonthList: FC<Props> = ({
  currentYearTab,
  nextYearTab,
  setCurrentYearTab,
  setNextYearTab,
  inputComponent,
}) => {
  const [selectedYear, setSelectedYear] = useState<'current' | 'next'>(
    'current'
  );

  const toggleYearTab = (val: 'current' | 'next') => setSelectedYear(val);

  const handleMonthChange = (month: string, checked: boolean) => {
    if (selectedYear === 'current') {
      setCurrentYearTab((val) => ({
        ...val,
        months: val.months.map((item) =>
          item.name === month ? { ...item, checked } : item
        ),
      }));
    }

    if (selectedYear === 'next') {
      setNextYearTab((val) => ({
        ...val,
        months: val.months.map((item) =>
          item.name === month ? { ...item, checked } : item
        ),
      }));
    }
  };

  const toggleAllMonths = (checked: boolean) => {
    if (selectedYear === 'current') {
      setCurrentYearTab((val) => ({
        ...val,
        months: val.months.map((item) => ({ ...item, checked })),
      }));
    }

    if (selectedYear === 'next') {
      setNextYearTab((val) => ({
        ...val,
        months: val.months.map((item) => ({ ...item, checked })),
      }));
    }
  };

  const getSelectedMonthsCount = useCallback((months: MonthItem[]) => {
    return months.filter((month) => month.checked).length;
  }, []);

  return (
    <SearchMonthListWrapper inputComponent={inputComponent}>
      <ToggleTabPanel
        toggleYearTab={toggleYearTab}
        selectedYear={selectedYear}
        currentYear={currentYearTab.year}
        nextYear={nextYearTab.year}
        currentYearSelectedMonths={getSelectedMonthsCount(
          currentYearTab.months
        )}
        nextYearSelectedMonths={getSelectedMonthsCount(nextYearTab.months)}
      />
      {selectedYear === 'current' ? (
        <YearTab
          handleMonthChange={handleMonthChange}
          months={currentYearTab.months}
          toggleAllMonths={toggleAllMonths}
        />
      ) : null}

      {selectedYear === 'next' ? (
        <YearTab
          handleMonthChange={handleMonthChange}
          months={nextYearTab.months}
          toggleAllMonths={toggleAllMonths}
        />
      ) : null}
    </SearchMonthListWrapper>
  );
};

export default SearchMonthList;
